














import { Vue, Component, Prop } from "vue-property-decorator";
import { SvgIcon } from "@brankas/web-ui";

@Component({
  name: "preview-modal",
  components: {
    SvgIcon,
  },
})
export default class PreviewModal extends Vue {
  @Prop({ type: Boolean, default: false }) show!: boolean;
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) imgUrl!: string;
}
